var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7071 15.2932L17.7071 5.29316C17.5672 5.1533 17.3891 5.05805 17.1951 5.01946C17.0011 4.98087 16.8 5.00067 16.6173 5.07636C16.4346 5.15205 16.2784 5.28022 16.1685 5.44467C16.0586 5.60913 16 5.80247 16 6.00025V13.5861L7.70709 5.29316C7.56724 5.1533 7.38906 5.05805 7.19508 5.01946C7.0011 4.98087 6.80003 5.00067 6.61731 5.07636C6.43458 5.15205 6.2784 5.28022 6.16852 5.44467C6.05864 5.60913 5.99999 5.80247 6 6.00025V26.0002C6 26.198 6.05864 26.3914 6.16852 26.5558C6.2784 26.7203 6.43458 26.8484 6.61731 26.9241C6.80003 26.9998 7.0011 27.0196 7.19508 26.981C7.38906 26.9424 7.56724 26.8472 7.70709 26.7073L16 18.4144V26.0002C16 26.198 16.0586 26.3914 16.1685 26.5558C16.2784 26.7203 16.4346 26.8484 16.6173 26.9241C16.8 26.9998 17.0011 27.0196 17.1951 26.981C17.3891 26.9424 17.5672 26.8472 17.7071 26.7073L27.7071 16.7073C27.8 16.6145 27.8736 16.5043 27.9239 16.3829C27.9741 16.2616 28 16.1316 28 16.0002C28 15.8689 27.9741 15.7389 27.9239 15.6176C27.8736 15.4962 27.8 15.386 27.7071 15.2932Z",
    fill: "#373473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextLesson);
export default __webpack_public_path__ + "static/media/next-lesson.aa6a9d29b09f442be6f9bb03f9636f7d.svg";
export { ForwardRef as ReactComponent };